<template>
  <div>
    <b-row>
      <b-col>
        <b-table
          responsive
          striped
          hover
          :fields="fields"
          :items="items"
          :busy="isBusy"
          show-empty
          empty-text="No matching records found"
        >
          <template v-slot:cell(status)="{ item }">
            <span
              :class="item.status == 'Active' ? 'text-success' : 'text-danger'"
              >{{ item.status == "Active" ? "Active" : "Inactive" }}</span
            >
          </template>
          <template v-slot:cell(start_datetime)="{ item }">
            {{ $moment(item.start_datetime).format("DD/MM/YYYY") }}
            <br />
            <small> {{ $moment(item.start_datetime).format("(HH:mm)") }}</small>
          </template>
          <template v-slot:cell(end_datetime)="{ item }">
            {{ $moment(item.end_datetime).format("DD/MM/YYYY") }}
            <br />
            <small> {{ $moment(item.end_datetime).format("(HH:mm)") }}</small>
          </template>
          <template v-slot:cell(actions)="{ item }">
            <div class="d-flex justify-content-center">
              <router-link :to="typePath(item)">
                <b-button variant="link" class="text-warning px-1 py-0">
                  <font-awesome-icon icon="pencil-alt" title="Edit" />
                </b-button>
              </router-link>
            </div>
          </template>

          <template v-slot:table-busy>
            <div class="text-center text-black my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="ml-2">Loading...</strong>
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <Pagination
      @handleChangeTake="handleChangeTake"
      :filter="filter"
      :rows="rows"
      @pagination="pagination"
    />
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";

export default {
  components: { Pagination },
  props: {
    filter: {
      required: true,
      type: Object,
    },

    fields: {
      required: true,
      type: Array,
    },
    items: {
      required: true,
      type: Array,
    },
    isBusy: {
      required: true,
      type: Boolean,
    },
    rows: {
      required: true,
      type: Number,
    },
    showingTo: {
      required: true,
      type: Number,
    },
  },
  methods: {
    typePath({ promotion_type, id }) {
      if (promotion_type.includes("Header"))
        return `promotions/promotions-header-discount/${id}`;
      else if (promotion_type.includes("Item"))
        return `promotions/promotions-items-discount/${id}`;
      else return `promotions/promotions-sap-discount/${id}`;
    },
    handleChangeTake(value) {
      this.filter.page = 1;
      this.filter.take = value;
      this.$emit("filterPage", this.filter);
    },
    pagination(page) {
      this.filter.page = page;
      this.$emit("filterPage", this.filter);
    },
    chkBirthday(birthday) {
      let birthDate = birthday ? birthday.search("00:00:00") : -1;
      if (birthDate === -1) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep thead {
  background-color: var(--theme-secondary-color);
  color: var(--font-color);
}
.color-red {
  color: #dc3545;
}
.color-green {
  color: #28a745;
}
.color-blue {
  color: lightcoral;
}
</style>
